module.exports = __webpack_public_path__ + "img/const.86262608.svg";